import {Box, Button, Grid, Stack, Typography} from '@mui/material';
import {t} from 'i18next';
import React from 'react';
import {
    PAGE_NAME,
    usePermissionsByPage,
} from '../../../../hooks/permissions/usePermissionsByPage';
import { IWorkflowMetricsProps } from './IWorkflowMetricsProps';
import AurIcon, { IconNames } from '../../../common/aur-icon/AurIcon';

const NonConsilioWorkflowMetrics: React.FC<IWorkflowMetricsProps> = ({
    projectDetails,
    reportMetrics,
    onTotalVolumesMappedClick,
}) => {
  const {canViewCompletedMappedDataReports} = 
    usePermissionsByPage(PAGE_NAME.PROJECT_OVERVIEW, projectDetails.projectId);

  return (
    <Box className="unavailable-project-metrics-view">
      <Grid container className="project-matrics-container">
        
        {/* Data Deliveries */}
        <Grid item xs={3} className="project-metric">
          <Stack spacing={1}>
            <Typography className="typo-text label2_size mute-text">
              {t('welcomeScreenSingleClient.mediaAndEvidence')}*
            </Typography>
            <Typography className="typo-text display3_size dash-line">
              --
            </Typography>
            <Grid container>
              <Grid item xs>
                
              </Grid>
              <Grid item xs="auto">
                <Button
                  className="button-icon button-exit buttonSmall_Size"
                  aria-label={t('welcomeScreenSingleClient.clickMediaEvidenceButton')}
                  disabled
                >
                  {t('welcomeScreenSingleClient.clickMediaEvidenceButton')}
                  &nbsp;
                  <AurIcon icon={IconNames.ChevronRight} />
                </Button>
              </Grid>
            </Grid>
          </Stack>
        </Grid>

        {/* Datasets Processing */}
        <Grid item xs={3} className="project-metric">
          <Stack spacing={1}>
            <Typography className="typo-text label2_size mute-text">
              {t('welcomeScreenSingleClient.datasetsProcessing')}*
            </Typography>
            <Typography className="typo-text display3_size dash-line">
              --
            </Typography>
            <Grid container>
              <Grid item xs>
                
              </Grid>
              <Grid item xs="auto">
                <Button
                  className="button-icon button-exit buttonSmall_Size"
                  aria-label={t('welcomeScreenSingleClient.clickDatasetProcessingButton')}
                  disabled
                >
                  {t('welcomeScreenSingleClient.clickDatasetProcessingButton')}
                  &nbsp;
                  <AurIcon icon={IconNames.ChevronRight} />
                </Button>
              </Grid>
            </Grid>
          </Stack>
        </Grid>

        {/* Processed Datasets */}
        <Grid item xs={3} className="project-metric">
          <Stack spacing={1}>
            <Typography className="typo-text label2_size mute-text">
              {t('welcomeScreenSingleClient.processedDatasets')}*
            </Typography>
            <Typography className="typo-text display3_size dash-line">
              --
            </Typography>
            <Grid container>
              <Grid item xs>
                
              </Grid>
              <Grid item xs="auto">
                <Button
                  className="button-icon button-exit buttonSmall_Size"
                  aria-label={t('welcomeScreenSingleClient.clickProcessedDatasetsButton')}
                  disabled
                >
                  {t('welcomeScreenSingleClient.clickProcessedDatasetsButton')}
                  &nbsp;
                  <AurIcon icon={IconNames.ChevronRight} />
                </Button>
              </Grid>
            </Grid>
          </Stack>
        </Grid>

        {/* Total Volumes Mapped */}
        <Grid item xs={3} className="project-metric">
          <Stack spacing={1}>
            <Typography className="typo-text label2_size mute-text">
              {t('welcomeScreenSingleClient.totalVolumesMapped')}*
            </Typography>
            <Typography className="typo-text display3_size dash-line">
              {canViewCompletedMappedDataReports ? (reportMetrics?.totalVolumesMapped ?? 0) : '--'}
            </Typography>
            <Grid container>
              <Grid item xs>
                
              </Grid>
              <Grid item xs="auto">
                <Button
                  className="button-icon button-exit buttonSmall_Size"
                  aria-label={t('welcomeScreenSingleClient.clickVolumesMappedButton')}
                  onClick={onTotalVolumesMappedClick}
                  disabled={!canViewCompletedMappedDataReports}
                >
                  {t('welcomeScreenSingleClient.clickVolumesMappedButton')}
                  &nbsp;
                  <AurIcon icon={IconNames.ChevronRight} />
                </Button>
              </Grid>
            </Grid>
          </Stack>
        </Grid>
      </Grid>

      <Typography className="typo-text subhead4_size project-disclaimer">
        {t('welcomeScreenSingleClient.nonConsilioProject.projectDisclaimer')}
      </Typography>

    </Box>
  );
};

export default NonConsilioWorkflowMetrics;
